
                            const chunks = `

/// #replace vMapUv = (uMapTransform * vec3(SIXTY_MAP_UV, 1.)).xy;
vMapUv = (uMapTransform * vec3(SIXTY_MAP_UV, 1.)).xy;
// vMapUv = ((vMapUv - 0.5) * 0.8) + 0.5;
`;

                            function replace(chunksCode = '', defaultShader = '') {
                                const chunks = parseCode(chunksCode);
                                chunks.forEach(({ target, replace }) => {
                                    defaultShader = defaultShader.replace(target, replace);
                                });

                                return defaultShader;
                            }

                            function parseCode(code, pattern = '/// #replace') {
                                const replacements = [];
                                const lines = code.trim().split('\n');

                                for (let i = 0; i < lines.length; i++) {
                                    const line = lines[i].trim();
                                    if (line.startsWith(pattern)) {
                                        const target = line.replace(pattern, '');
                                        const replaceLines = [];
                                        let j = i + 1;

                                        while (j < lines.length && !lines[j].trim().startsWith(pattern)) {
                                            const nextLine = lines[j].trim();
                                            if (nextLine) {
                                                replaceLines.push(nextLine);
                                            }
                                            j++;
                                        }

                                        const replace = replaceLines.join('\n');
                                        replacements.push({ target: target.trim(), replace: replace.trim() });

                                        i = j - 1;
                                    }
                                }
                                return replacements;
                            }

                            export default {
                                use: (el) => {
                                    const instance = el.material || el;
                                    instance['vertexShader'] = replace(chunks, instance['vertexShader']);
                                    instance.needsUpdate = true;
                                    return el;
                                }
                            }
                        